// Битый UTF-8 в данных превращает json_encode в пустую строку — страница не должна падать.
export function parseJsonAttribute<T>(element: Element | null, name: string, fallback: T): T {
    try {
        return JSON.parse(element?.getAttribute(name) || 'null') ?? fallback;
    } catch {
        return fallback;
    }
}
